import React from 'react'
import { Item } from 'semantic-ui-react'
import { Product } from '../../../hooks/useProduct'
import { ProductAttribute } from './ProductAttribute'

type DisplayKey = { key: keyof Product; title: string }

const displayAttributes: DisplayKey[] = [
  { key: 'name', title: 'Name' },
  { key: 'brand', title: 'Brand' },
  { key: 'description', title: 'Description' },
  { key: 'category', title: 'Lineage' },
  { key: 'kind', title: 'Product Type' },
  { key: 'root_subtype', title: 'Product Subtype' },
  { key: 'kind_subtype', title: 'Brand Subtype' },
  { key: 'amount', title: 'Amount' },
  { key: 'dosage', title: 'Dosage' },
  { key: 'cbd_dosage_milligrams', title: 'CBD Dosage(mg)' },
  { key: 'thc_dosage_milligrams', title: 'THC Dosage(mg)' },
  { key: 'net_weight_grams', title: 'Net Weight(g)' },
  { key: 'quantity_value', title: 'Quantity Value' },
  { key: 'quantity_units', title: 'Quantity Units' },
]

export const ProductDetails = ({ product }: { product: Product }) => (
  <Item.Group style={{ overflowY: 'auto', flex: '1 1 1px' }}>
    {displayAttributes.map(({ title, key }) => {
      return <ProductAttribute title={title} value={product[key]} key={key} />
    })}
  </Item.Group>
)
